/*
 * Cosmetic relabel of the Zapiet delivery method in the cart drawer:
 * "Local Delivery" -> "Delivery".
 *
 * NOTE: this label is owned by the Zapiet app, not the theme. This script runs
 * after Zapiet renders and rewrites the text. The clean long-term fix is to
 * rename the method inside the Zapiet app settings; if that's done, this can be
 * removed. Extend MAP below to relabel other Zapiet strings.
 */
(function () {
  var MAP = {
    'Local Delivery': 'Delivery',
  };

  function relabel(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var key = node.nodeValue.trim();
      if (MAP[key]) {
        node.nodeValue = node.nodeValue.replace(key, MAP[key]);
      }
    }
  }

  function run() {
    document
      .querySelectorAll('#storePickupApp, [class*="checkoutMethod"], [class*="zapiet"]')
      .forEach(relabel);
  }

  function init() {
    run();
    // Zapiet renders/re-renders asynchronously (drawer open, cart update) — watch for it.
    var target = document.getElementById('cart-drawer') || document.body;
    new MutationObserver(run).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
